/* eslint-disable react/jsx-props-no-spreading */
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import makeStyles from '@mui/styles/makeStyles';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { Button, Box, Typography } from '@mui/material';
import { TabPanel } from 'components/elements';
import { EventIcon } from 'components/elements/Icons';
import { AppointmentsList, BookAppointment } from 'components/modules';
import { periods } from 'const';
import { useDeviceDetect, useModal, useOrganization } from 'hooks';
import Styles from './styles';

const useStyles = makeStyles(Styles);

const a11yProps = (index) => ({
  id: `simple-tab-${index}`,
  'aria-controls': `simple-tabpanel-${index}`,
});

function Appointments() {
  const classes = useStyles(Styles);
  const { t } = useTranslation('labels');
  const { isDesktop } = useDeviceDetect();
  const [tabValue, setTabValue] = useState(0);
  const { handleModal } = useModal();
  const { data: organization } = useOrganization();

  const handleChange = (event, newTabValue) => setTabValue(newTabValue);
  const toggleBookAppointmentModal = () => handleModal(<BookAppointment />, { size: 'small', removeOutsideClick: true });

  return (
    <>
      <Box className={classes.tabsHeader}>
        <Box className={classes.wrapper}>
          {organization.isPatientHealthcareServicesEnabled === true ? (
            <Button className={classes.bookAppointmentButton} onClick={toggleBookAppointmentModal} variant="contained">
              <EventIcon classes={classes.calendarIcon} />
              {isDesktop && (
                <Typography className={classes.bookAppointmentButtonText} variant="body2" component="span">
                  {t('book_appointment')}
                </Typography>
              )}
            </Button>
          ) : (
            <Box />
          )}
          <Tabs classes={{ flexContainer: classes.tabsContainer, root: classes.tabsWrapper }} value={tabValue} onChange={handleChange} aria-label="appointments tabs">
            <Tab classes={{ root: classes.tab }} label={t('upcoming_appointments')} {...a11yProps(0)} />
            <Tab classes={{ root: classes.tab }} label={t('past_appointments')} {...a11yProps(1)} />
          </Tabs>
        </Box>
      </Box>
      <TabPanel value={tabValue} index={0}>
        <AppointmentsList period={periods.active} />
      </TabPanel>
      <TabPanel value={tabValue} index={1}>
        <AppointmentsList period={periods.history} />
      </TabPanel>
    </>
  );
}

export default Appointments;
